// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "sos-medicos.firebaseapp.com",
  "projectId": "sos-medicos",
  "storageBucket": "sos-medicos.appspot.com",
  "messagingSenderId": "812438815221",
  "appId": "1:812438815221:web:68342dfe014fe81ee3e0bc",
  "measurementId": "G-V70W50G438",
  "apiKey": "AIzaSyB5AZ-KQt5BOSiswJP8R8l3c5VV85Xqku8"
};
